// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"6f0ac934","213":"3317431a","732":"be7fbf8b"}[chunkId] + ".chunk.js";
};